import { env } from '@/env'
import { api } from '@/services/fintalk/api'

export interface Company {
  _id: string
  name: string
  picture: string
  active: boolean
  created_at: Date
  updated_at: Date
}

export async function listCompanies(): Promise<Company[]> {
  const resp = await api.get<Company[]>(
    env.VITE_FINTALK_BACKOFFICE_URL,
    '/companies',
  )

  return resp.body
}
